import {DefaultTheme} from "styled-components";

const BaseTheme: DefaultTheme = {
  id: "t_002",
  name: "secondary",
  palette: {
    background: "#FFFFFF",
    pageBackground: "#F7F7F7",
    danger: '#FF4C4D',
    primary: {
      primary120:'#007DDC',
      primary110:'#CFF7C4',
      primary100:'#136C3D',
      primary99: '#CFF7C4',
      primary90: '#EAF0FF',
      primary80: '#D3E3FF',
      primary70: '#EEF9EC',
      primary60: '#CFF7C4',
      primary50: '#B9EBAD',
      primary40: '#B9EBAD',
      primary30: '#29A34E',
      primary20: '#23904D',
      primary10: '#136C3D',
      primary00: '#066021',
    },
    secondary: {
      secondary80: '#CBC2DB',
      secondary100: '#EEF9EC',
      secondary200: '#CFF7C4',
      secondary300: '#B9EBAD',
      secondary400: '#99E5AB',
      secondary500: '#29A34E',
      secondary600: '#23904D',
      secondary700: '#136C3D',
      secondary800: '#066021',
    },
    neutral: {
      white: "#FFFFFF",
      greys94: '#EEEFF1',
      greys95: '#EFF0F5',
      greys99: '#F7F7F7',
      greys100: '#DFE2EB',
      greys200: '#C3C6CF',
      greys300: '#A8ABB4',
      greys400: '#8E9199',
      greys500: '#74777F',
      greys600: '#5B5E66',
      greys700: '#43474E',
      greys800: '#2D3037',
      greys900: '#181C22',
    },
    brand: {
      brand007: '#007DDC'
    },
    icon: {
      primary: "#FFFFFF",
      secondary: "#000000"
    },
    button: {
      primary: {
        text: "#23904D",
        background: "#EAF0FF",
        icon: "#23904D",
        border: "#EAF0FF",
        disableText: "#43474E",
        disableBackground: "#EEEFF1",
        disableIcon: "#43474E",
        disableBorder: "#43474E"
      },
      secondary: {
        text: "#FFFFFF",
        background: "#23904D",
        icon: "#FFFFFF",
        border: "#23904D",
        disableText: "#2D3037",
        disableBackground: "#DFE2EB",
        disableIcon: "#74777F",
        disableBorder: "#DFE2EB"
      },
      light: {
        text: "#74777F",
        background: "#FFFFFF",
        icon: "#23904D",
        border: "#DFE2EB",
        disableText: "#2D3037",
        disableBackground: "#DFE2EB",
        disableIcon: "#74777F",
        disableBorder: "#DFE2EB"
      },
      primaryLight:{
        text: "#23904D",
        background: "#EAF0FF",
        icon: "#23904D",
        border: "#EAF0FF",
        disableText: "#2D3037",
        disableBackground: "#DFE2EB",
        disableIcon: "#74777F",
        disableBorder: "#DFE2EB"
      },
      secondaryLight:{
        text: "#23904D",
        background: "#FFFFFF",
        icon: "",
        border: "#FFFFFF",
        disableText: "#2D3037",
        disableBackground: "#DFE2EB",
        disableIcon: "#74777F",
        disableBorder: "#DFE2EB"
      }
    },
    checkbox: {
      active: '#007DDC',
      inactive: '#8E9199',
      disable: '#C3C6CF'
    },
    ratings: {
      yellow500: '#FFE200',
      green500: '#00B000'
    }
  },
  typography: {
    fontFamily: {
      regular: "Roboto-Regular",
      medium: "Roboto-Medium",
      bold: "Roboto-Bold"
    },
    fontWeight: {
      normal: 400,
      medium: 500,
      bold: 700,
    },
    font: {
      headlineLarge: {
        size: "32px",
        lineHeight: "36px"
      },
      headlineMedium: {
        size: "28px",
        lineHeight: "32px"
      },
      headlineRegular: {
        size: "24px",
        lineHeight: "32px"
      },
      titleLarge: {
        size: "20px",
        lineHeight: "28px"
      },
      titleMedium: {
        size: "18px",
        lineHeight: "20px"
      },
      bodySmall: {
        size: "12px",
        lineHeight: "16px"
      },
      bodyRegular: {
        size: "12px",
        lineHeight: "16px"
      },
      bodyMedium: {
        size: "14px",
        lineHeight: "20px"
      },
      bodyLarge: {
        size: "16px",
        lineHeight: "24px"
      },
      labelXss: {
        size: "8px",
        lineHeight: "12px"
      },
      labelXs: {
        size: "10px",
        lineHeight: "12px"
      },
      labelSmall: {
        size: "11px",
        lineHeight: "12px"
      },
      labelMedium: {
        size: "12px",
        lineHeight: "16px"
      },
      labelLarge: {
        size: "14px",
        lineHeight: "20px"
      }
    }
  }
};
export default BaseTheme;
